// extracted by mini-css-extract-plugin
export default {"likeIcon":"battle_likeIcon__vXIa2","blockHidden":"battle_blockHidden__bUr05","blockShown":"battle_blockShown__ybERf"};